import * as React from 'react';
import {Pdf} from "../../pdf/Pdf";
import {
    FoundationsReportBottomContent,
    FoundationsReportLeftAndRightPair, FoundationsReportTeamContent,
    FoundationsReportTopContent,
    PVAStyle
} from '../../reports';
import {BaseRouteProps} from '../../../interfaces';
import {SurveyVersion, Style, StyleText} from '../../../models';
import {ReportType} from "../../../enums";
import {FilterStore} from "../../../stores";
import { NotificationService } from '../../../services';

interface PdfBriefProps extends Partial<BaseRouteProps<{}>> {
    selectedUserData: any;
    surveyVersion: SurveyVersion;
    allStyles: Style[];
    notificationService: NotificationService;
    FilterStore?: FilterStore;
}

export class PdfBrief extends React.Component<PdfBriefProps> {
    get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return ReportType.Standard;
    }
    
    public render() {
        const { selectedUserData, surveyVersion, allStyles, notificationService } = this.props;
        
        if (!selectedUserData || !selectedUserData.style) {
            return null;
        }

        const currentStyle = selectedUserData.style;
        const badgeColor = currentStyle ? `var(--pva-${currentStyle.name.toLowerCase()})` : 'var(--blue)';
        const currentStyleName = currentStyle ? currentStyle.name.toLowerCase() : '';
        const checkmarkUrl = currentStyleName ? `url("/images/checkmark-${currentStyleName}.svg")` : 'url("/images/checkmark.svg")';
        const checkMarkRedUrl = currentStyleName ? `url("/images/check-mark-${currentStyleName}.svg")` : 'url("/images/check mark red.svg")';

        const styleTexts = currentStyle && currentStyle.styleTexts || [];
        const sortedAdditionalStyles:any = styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).sort((one: StyleText, two: StyleText) => {
            if (one.sort > two.sort) {
                return 1;
            } else if (one.sort < two.sort) {
                return -1;
            }
            return 0;
        });

        let page = 1;
        let maxPage = 8;

        return (
            <Pdf fontSize="8.5px">
                <Pdf.Page>
                    <PVAStyle
                        notificationService={notificationService}
                        history={this.props.history as any}
                        location={this.props.location as any}
                        match={this.props.match as any}
                        style={selectedUserData.style}
                        brief={selectedUserData.style.brief}
                        content={selectedUserData.style.content}
                        core={selectedUserData.style.core}
                        name={selectedUserData.name}
                        surveyVersion={surveyVersion}
                        allStyles={allStyles}
                        selectedUserData={selectedUserData}
                        hideDichotomies={true}
                        hideButtons={true}
                        showTraits={true}
                    />

                    <FoundationsReportTopContent style={selectedUserData.style} />
                    <FoundationsReportLeftAndRightPair style={selectedUserData.style} badgeColor={badgeColor} />
                    <FoundationsReportBottomContent style={selectedUserData.style} />

                    <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                </Pdf.Page>
                <Pdf.Page>
                    <PVAStyle
                        notificationService={notificationService}
                        history={this.props.history as any}
                        location={this.props.location as any}
                        match={this.props.match as any}
                        style={selectedUserData.style}
                        brief={selectedUserData.style.brief}
                        content={selectedUserData.style.content}
                        core={selectedUserData.style.core}
                        name={selectedUserData.name}
                        surveyVersion={surveyVersion}
                        allStyles={allStyles}
                        selectedUserData={selectedUserData}
                        hideDichotomies={true}
                        hideButtons={true}
                        showTraits={true}
                    />

                    <FoundationsReportTeamContent style={selectedUserData.style as any} />

                    <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                </Pdf.Page>

                {sortedAdditionalStyles.map((styleText: StyleText) => {
                    return <Pdf.Page key={styleText.keyName}>
                        <PVAStyle
                            notificationService={notificationService}
                            history={this.props.history as any}
                            location={this.props.location as any}
                            match={this.props.match as any}
                            style={selectedUserData.style}
                            brief={selectedUserData.style.brief}
                            content={selectedUserData.style.content}
                            core={selectedUserData.style.core}
                            name={selectedUserData.name}
                            surveyVersion={surveyVersion}
                            allStyles={allStyles}
                            selectedUserData={selectedUserData}
                            hideDichotomies={true}
                            hideButtons={true}
                            showTraits={true}
                        />

                        {styleText.keyName && <div className={`custom-content ${styleText.keyName.toLowerCase().trim().replace(" ", "-")}-content`} style={{ '--custom-content-color': badgeColor, '--checkmark-url': checkmarkUrl, '--check-mark-url': checkMarkRedUrl } as any} key={styleText.value} dangerouslySetInnerHTML={{ __html: styleText.value}}/>}

                        <Pdf.Footer currentPage={page++} totalPages={maxPage} />
                    </Pdf.Page>;
                })}
            </Pdf>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/individual/pdf_brief.tsx